var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Animations = /** @class */ (function () {
    function Animations() {
        var _this = this;
        this.AddToShoppingCartAnimation = function (dom, img, submitBtn) { return __awaiter(_this, void 0, void 0, function () {
            var cart, imgClone_1;
            return __generator(this, function (_a) {
                cart = dom.getElementById("cart");
                if (img) {
                    imgClone_1 = img.cloneNode();
                    imgClone_1.style.top = submitBtn.getBoundingClientRect().top + window.scrollY + "px";
                    imgClone_1.style.left = submitBtn.getBoundingClientRect().left + window.scrollX + "px";
                    imgClone_1.style.opacity = "0.8";
                    imgClone_1.style.position = "absolute";
                    imgClone_1.style.height = "150px";
                    imgClone_1.style.width = "150px";
                    imgClone_1.style.zIndex = "10000";
                    imgClone_1.style.border = "1px solid grey";
                    dom.getElementsByTagName("body")[0].append(imgClone_1);
                    imgClone_1.animate({
                        top: cart.offsetTop + 10 + window.scrollY + "px",
                        left: cart.offsetLeft + 10 + window.scrollX + "px",
                        width: 75 + "px",
                        height: 75 + "px"
                    }, { duration: 10000, easing: "ease-in-out" }).onfinish = function () {
                        imgClone_1.remove();
                    };
                    // console.log(imgClone);
                    //     .offset({
                    //         top: img.offset().top,
                    //         left: img.offset().left
                    //     })
                    //     .css({
                    //         'opacity': '0.8',
                    //         'positions': 'absolute',
                    //         'height': '150px',
                    //         'width': '150px',
                    //         'z-index': '10000',
                    //         'border': '1px solid grey'
                    //     })
                    //     .appendTo(dom.getElementsByTagName("body")[0])
                    //     .animate({
                    //         'top': cart.offset().top + 10,
                    //         'left': cart.offset().left + 10,
                    //         'width': 75,
                    //         'height': 75
                    //     }, 1000, 'easeInOutExpo');
                    //
                    // setTimeout(function () {
                    //     cart.effect("shake", {
                    //         times: 2
                    //     }, 200);
                    // }, 1500);
                    //
                    // imgclone.animate({
                    //     'width': 0,
                    //     'height': 0
                    // }, function () {
                    //
                    // })
                }
                return [2 /*return*/];
            });
        }); };
        this.RemoveFromShoppingCartSidaBarAnimation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        this.AddItemToShoppingCartSideBarAnimation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        this.RemoveItemFromShoppingCartPageAnimation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        this.AddAddressToShoppingCartPage = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
    }
    return Animations;
}());
export default Animations;
